export default "__VITE_ASSET__Tkzoo8Mb__"